export const OFFER_BOX_WIDTH = 388
export const AP_DESKTOP_LARGE_COLUMN_WIDTH = 640
